import React from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { SnackbarProvider } from "notistack";
import SignInSide from './components/SignInSide';
import Mapandtrack from "./components/Mapandtrack";
import Dashboard from "./components/Dashboard";
import { ProtectedRoute } from './components/ProtectedRoute';
import { MapTrackProvider } from "./context/Maptrackcontext";

function App() {
  return (
    <SnackbarProvider>
      <Router>
        <MapTrackProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/Dashboard" replace />} />
            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<SignInSide />} />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </MapTrackProvider>
      </Router>
    </SnackbarProvider>
  );
}

export default App;